/**
 * @file   src\components\ScrollToTop.tsx
 * @brief  ScrollToTop component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { useEffect,useLocation } from '../utils/thirdpartyComponents';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
